/* eslint-disable camelcase */
import PropTypes from "prop-types";

export const backgroundColorProp = PropTypes.string;

export const justifyCotnentProp = PropTypes.oneOf([
    "flex-start",
    "center",
    "flex-end",
    "stretch",
    "space-between",
    "space-around",
    "space-evenly",
]);

export const alignItemsProp = PropTypes.oneOf(["normal", "stretch", "center", "flex-start", "flex-end"]);

export const horizontalAlignmentProp = PropTypes.oneOf(["left", "center", "right"]);

export const verticalAlignmentProp = PropTypes.oneOf(["top", "center", "bottom"]);

export const paddingOptionsProps = PropTypes.object;

export const textColorProp = PropTypes.oneOf(["black", "white", "yellow", "red", "dark_green"]);
